export const BRACELET_SIZE_NO_ADJUSTMENT = 'No adjustment';

export const WBR_WRIST_SIZE_MM = [
  BRACELET_SIZE_NO_ADJUSTMENT,
  '120mm',
  '125mm',
  '130mm',
  '135mm',
  '140mm',
  '145mm',
  '150mm',
  '155mm',
  '160mm',
  '165mm',
  '170mm',
  '175mm',
  '180mm',
  '185mm',
  '190mm',
  '195mm',
  '200mm',
  '205mm',
  '210mm',
  '215mm',
  '220mm',
];

export const WBR_WRIST_SIZE_IN = [
  BRACELET_SIZE_NO_ADJUSTMENT,
  '4,7in',
  '4,9in',
  '5,1in',
  '5,3in',
  '5,5in',
  '5,7in',
  '5,9in',
  '6,1in',
  '6,3in',
  '6,5in',
  '6,7in',
  '6,9in',
  '7,1in',
  '7,3in',
  '7,5in',
  '7,7in',
  '7,9in',
  '8,1in',
  '8,2in',
  '8,4in',
  '8,6in',
];
export const findAttributeValue = (product: any, attributeName: string) => {
  const attribute = product[attributeName];

  return attribute?.values?.[0]?.name ?? null;
};

export const getFilteredWristSizesByCountryAndProduct = (
  country: string,
  product: object,
) => {
  const minInch = findAttributeValue(product, 'wristSizeMinInch');
  const maxInch = findAttributeValue(product, 'wristSizeMaxInch');
  const minMM = findAttributeValue(product, 'wristSizeMinMm');
  const maxMM = findAttributeValue(product, 'wristSizeMaxMm');
  let wristSizes: string[];
  let min: number | null = null;
  let max: number | null = null;

  if (country === 'US') {
    wristSizes = WBR_WRIST_SIZE_IN;
    min = minInch ? Math.round(parseFloat(minInch) * 10) / 10 : null;
    max = maxInch ? Math.round(parseFloat(maxInch) * 10) / 10 : null;
  } else {
    wristSizes = WBR_WRIST_SIZE_MM;
    min = minMM ? parseInt(minMM) : null;
    max = maxMM ? parseInt(maxMM) : null;
  }

  if (min === null || max === null) {
    return wristSizes;
  }

  return wristSizes.filter((size) => {
    if (size === BRACELET_SIZE_NO_ADJUSTMENT) {
      return true;
    }

    let value: number;

    if (country === 'US') {
      value = parseFloat(size.replace('in', '').replace(',', '.'));
    } else {
      value = parseInt(size.replace('mm', ''));
    }

    return min !== null && max !== null && value >= min && value <= max;
  });
};
